// Local runtime only. No analytics transport, headers, form bodies or WS payloads.
export function diagnosticText(value) {
  return String(value ?? '')
    .replace(/(?:https?|wss?):\/\/[^\s"<>]+/g, raw => {
      try {const url=new URL(raw);return `${url.protocol}//${url.host}${url.pathname}`;}
      catch {return '[redacted-url]';}
    })
    .replace(/eyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+/g,'[redacted-jwt]')
    .replace(/(bearer\s+)[^\s,;]+/gi,'$1[redacted]')
    .replace(/(["']?(?:api_key|access_token|refresh_token|signedInstance|signed_instance|instance|grant|X-Wix-Installation|token|code|state|secret|password|authorization)["']?\s*[=:]\s*)(?:"[^"]*"|'[^']*'|[^\s,;&]+)/gi,'$1[redacted]').slice(0,1600);
}

const active=process.env.REACT_APP_WIX_LOCAL_PROFILE === 'live-local';
const rawFetch=window.fetch.bind(window);
let count=0;
export function localDiagnostic(event, fields={}) {
  if(!active || ++count>300) return;
  const safe={event,path:window.location.pathname};
  for(const key of ['message','source','request_id','status','code']) {
    if(['string','number'].includes(typeof fields[key])) safe[key]=diagnosticText(fields[key]);
  }
  rawFetch('/api/local/diagnostics',{method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify(safe),keepalive:true}).catch(()=>{});
}

export function installLocalDiagnostics() {
  if(!active) return;
  window.addEventListener('error',e=>localDiagnostic('uncaught_error',{message:e.message,source:e.filename}));
  window.addEventListener('unhandledrejection',e=>localDiagnostic('unhandled_rejection',{
    message:e.reason instanceof Error ? e.reason.message : typeof e.reason==='string' ? e.reason : 'Non-error rejection'}));
  const NativeWebSocket=window.WebSocket;
  window.WebSocket=class extends NativeWebSocket {
    constructor(...args) {
      super(...args);
      const source=String(args[0]).split(/[?#]/)[0];
      this.addEventListener('open',()=>localDiagnostic('websocket_open',{source}));
      this.addEventListener('error',()=>localDiagnostic('websocket_error',{source}));
      this.addEventListener('close',e=>localDiagnostic('websocket_close',{source,code:e.code}));
    }
  };
}
